import Mobile from './mobile.svg';
import NewThisWeek from './new-this-week.svg';
import Search from './search.svg';
import Signup from './signup.svg';
import Users from './users.svg';

export default {
  'segments/mobile': Mobile,
  'segments/new-this-week': NewThisWeek,
  'segments/search': Search,
  'segments/signup': Signup,
  'segments/users': Users,
};
